import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class DashboardStore {
  setCurrentUser(currentUser: any) {
    localStorage.setItem('currentUser', JSON.stringify(currentUser));
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('currentUser'));
  }

  setCurrentUserName(currentUserName: string) {
    localStorage.setItem('currentUserName', currentUserName);
  }

  getCurrentUserName() {
    return localStorage.getItem('currentUserName');
  }

  setBankTransferCount(bankTransferCount: string) {
    localStorage.setItem('bankTransferCount', bankTransferCount);
  }

  getBankTransferCount() {
    return localStorage.getItem('bankTransferCount');
  }

  setUssdCount(ussdCount: string) {
    localStorage.setItem('ussdCount', ussdCount);
  }

  getUssdCount() {
    return localStorage.getItem('ussdCount');
  }

  setAmountReceived(amountReceived: string) {
    localStorage.setItem('amountReceived', amountReceived);
  }

  getAmountReceived() {
    return localStorage.getItem('amountReceived');
  }

  setBalance(balance: string) {
    localStorage.setItem('balance', balance);
  }

  getBalance() {
    return localStorage.getItem('balance');
  }

  setIsBalanceHidden(hidden: boolean) {
    localStorage.setItem('isBalanceHidden', hidden.toString());
  }

  getIsBalanceHidden() {
    return localStorage.getItem('isBalanceHidden');
  }

  setIsMoreShown(shown: boolean) {
    localStorage.setItem('isMoreShown', shown.toString());
  }

  getIsMoreShown() {
    return localStorage.getItem('isMoreShown');
  }

  setIsInfoDismissed(dismissed: boolean) {
    localStorage.setItem('isInfoDismissed', dismissed.toString());
  }

  getIsInfoDismissed() {
    return localStorage.getItem('isInfoDismissed');
  }

  setIsDateChanged(changed: boolean) {
    localStorage.setItem('isDateChanged', changed.toString());
  }

  getIsDateChanged() {
    return localStorage.getItem('isDateChanged');
  }

  setPickerDate(pickerDate: string) {
    localStorage.setItem('pickerDate', pickerDate);
  }

  getPickerDate() {
    return localStorage.getItem('pickerDate');
  }

  setActiveIndex(activeIndex: string) {
    localStorage.setItem('activeIndex', activeIndex);
  }

  getActiveIndex() {
    return parseInt(localStorage.getItem('activeIndex'), 10);
  }

  setIsNewAccountAdded(added: boolean) {
    localStorage.setItem('isNewAccountAdded', added.toString());
  }

  getIsNewAccountAdded() {
    return localStorage.getItem('isNewAccountAdded');
  }

  setAccounts(accounts: any) {
    localStorage.setItem('accounts', JSON.stringify(accounts));
  }

  getAccounts() {
    return JSON.parse(localStorage.getItem('accounts'));
  }

  setAccountId(accountId: any) {
    localStorage.setItem('accountId', accountId);
  }

  getAccountId() {
    return localStorage.getItem('accountId');
  }

  setAccountIdsArray(array: any) {
    localStorage.setItem('accountIdsArray', array);
  }

  getAccountIdsArray() {
    return localStorage.getItem('accountIdsArray');
  }

  setAccountSummary(accountSummary: any) {
    localStorage.setItem('accountSummary', JSON.stringify(accountSummary));
  }

  getAccountSummary() {
    return JSON.parse(localStorage.getItem('accountSummary'));
  }

  setIsDeviceIdRegistered(registered: boolean) {
    localStorage.setItem('isDeviceIdRegistered', registered.toString());
  }

  getIsDeviceIdRegistered() {
    return localStorage.getItem('isDeviceIdRegistered');
  }

  setIsDeviceIdUpdated(updated: boolean) {
    localStorage.setItem('isDeviceIdUpdated', updated.toString());
  }

  getIsDeviceIdUpdated() {
    return localStorage.getItem('isDeviceIdUpdated');
  }
}

